import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { inject } from "mobx-react";
import { TableNameAvatarCell, StatsPreview, DotLoader } from "@myplay/ui";

import getAgeFromDate from '../../utils/getAgeFromDate';
import { toTitleCase } from '../../utils/stringManipulations';
import I18N from '../../I18N';
import { TableIconsCell } from '..';

const AthletesTableItem = ({ athlete, onDelete, isSelected, TeamsStore, currentTeamId })=> {
  const { avatar, firstName, lastName, jersey, wight, hight, pointsPerGame, position, birthdate, avatarBgColor, _id } = athlete;
  const [ selectedPlayerStats, setSelectedPlayerStats ] = useState(null);
  const age = getAgeFromDate(birthdate);

  useEffect(()=> {
    if (isSelected) {
      getPlayerStats();
    }
  }, [isSelected]);

  const getPlayerStats = async ()=> {
    const { getPlayerStats } = TeamsStore;
    const stats = await getPlayerStats(_id, currentTeamId);
    setSelectedPlayerStats(stats);
  }

  return (
    <Fragment>
      <TableNameAvatarCell firstName={firstName} lastName={lastName} avatar={avatar} avatarBgColor={avatarBgColor}/>
      <span className="athletes-table-item__jersey" >{jersey}</span>
      <span>{position}</span>
      <span>{age}</span>
      <span>{wight}</span>
      <span>{hight}</span>
      <span>{pointsPerGame}</span>
      <div className="athletes-table-item__icons-container">
        <TableIconsCell onDeleteClick={onDelete}/>
      </div>
      {isSelected &&
        <div className="athletes-table-item__stats-wrapper">
          {selectedPlayerStats ?
            <Fragment>
              <p className="athletes-table-item__stats-wrapper__headline" >{toTitleCase(I18N.t("SEASONAL_AVERAGE"))}</p>
              <StatsPreview bars={selectedPlayerStats.bars} donuts={selectedPlayerStats.donuts} isPlayerProfile />
            </Fragment>:
            <DotLoader />
          }
        </div>
      }
    </Fragment>
  );
};

AthletesTableItem.propTypes = {
  athlete: PropTypes.object
};

AthletesTableItem.defaultProps = {
  athlete: {}
};

export default inject("TeamsStore")(AthletesTableItem);